module.exports = __webpack_public_path__ + "src/app/assets/images/speakers/sfregola.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/speakers/sfregola.png
// module id = 610
// module chunks = 0